export const allergyOptions = [
  { label: 'Eggs', value: 'Eggs' },
  { label: 'Fish', value: 'Fish' },
  { label: 'Latex', value: 'Latex' },
  { label: 'Milk', value: 'Milk' },
  { label: 'Peanut', value: 'Peanut' },
  { label: 'Pollen', value: 'Pollen' },
  { label: 'Shellfish', value: 'Shellfish' },
  { label: 'Soy', value: 'Soy' },
  { label: 'Wheat', value: 'Wheat' },
  { label: 'Dust', value: 'Dust' },
]

/** @deprecated Prefer catalog from GET /api/v1/medical-condition */
export const conditionOptions = [
  { label: 'Hypertension', value: 'Hypertension' },
  { label: 'Diabetes', value: 'Diabetes' },
  { label: 'Coronary Artery Disease ', value: 'Coronary Artery Disease ' },
  { label: 'Asthma', value: 'Asthma' },
  { label: 'Depression', value: 'Depression' },
  { label: 'Osteoarthritis', value: 'Osteoarthritis' },
  { label: 'Alzheimer’s Disease', value: 'Alzheimer’s Disease' },
  { label: 'Cancer', value: 'Cancer' },
  { label: 'Stroke', value: 'Stroke' },
  { label: 'Pneumonia', value: 'Pneumonia' },
]

export const insuranceProviderOptions = [
  { label: 'Provider 1', value: 'Provider1' },
  { label: 'Provider 2', value: 'Provider2' },
]

export enum PatientRelationship {
  SPOUSE = 'Spouse',
  CHILD = 'Child',
  PARENT = 'Parent',
  SIBLING = 'Sibling',
}

export const familyMemberOptions = Object.values(PatientRelationship).map(
  (value) => ({ label: value, value }),
)

export const preferredAppointmentTimesOptions = [
  { label: 'Mon-Tue (9AM-11AM)', value: 'Mon-Tue (9AM-11AM)' },
  { label: 'Thu-Fri (2PM-4PM)', value: 'Thu-Fri (2PM-4PM)' },
]

export const contactViaOptions = [
  { label: 'Phone', value: 'Phone' },
  { label: 'SMS', value: 'SMS' },
  { label: 'Email', value: 'Email' },
  { label: 'App', value: 'App' },
]

export const providerOptions = [
  { label: 'Provider 1', value: 'Provider1' },
  { label: 'Provider 2', value: 'Provider2' },
]

export const hygienistOptions = [
  { label: 'Hygienist 1', value: 'Hygienist1' },
  { label: 'Hygienist 2', value: 'Hygienist2' },
]
